// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconxieyiguanli[data-v-65541682] {\n  color: #9bacbf;\n  margin-right: 8px;\n}\n.ty-drawer-footer[data-v-65541682] {\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.ty-drawer-content[data-v-65541682] {\n  width: 94%;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
